import React from 'react'
import { ViewStyle } from 'react-native'
import { TaskExperience } from '@dialogue/silkroad'

import MemberTaskBannerBase from 'APP/Components/MemberTaskBar/MemberTaskBannerBase'
import I18n from 'APP/I18n'
import type { MemberTaskBannerProps } from '../types'

export type BookingBannerProps = MemberTaskBannerProps<typeof TaskExperience.BookAppointment> & {
  style?: ViewStyle
}

const MemberTaskBannerBooking: React.FC<BookingBannerProps> = ({
  onPress,
  testID = 'MEMBER_TASK_BANNER_BOOKING',
  style,
}) => {
  const title = I18n.t('MemberTaskBar.bookAppointment.title') as string

  return (
    <MemberTaskBannerBase
      title={title}
      icon="calendar-month"
      accessibilityLabel={title}
      testID={testID}
      style={style}
      onPress={onPress}
    />
  )
}

export default MemberTaskBannerBooking
